import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {updateNavigationParam, updateUser} from "../../redux/systemSlice";
import {connect} from "react-redux";
import Utils, {withRouterHOC} from "../../utils";
import Storage from '../../utils/storage';
import {Link} from "react-router-dom";
import {withCookies} from "react-cookie";


import {ReactComponent as LogoIcon} from "../../images/logo.svg";
import LoginPortalIcon from "../../images/login-portal.png";
import LoginBusinessIcon from "../../images/login-business.png";


import './login.css';

class LoginBreeding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: null,
            password: null,
            errorText: null,

            activeTab: 'partners',
            tabs: {
                portal: 'на портал',
                partners: 'партнерам'
            },

            tokenPortal: null,
            tokenPartners: null,
        };
    }

    componentDidMount() {
        this.props.updateNavigationParam({
            page: 'login',
        })

        Utils.setPageTitle(`Авторизация | ПабХаб`)
    }

    render() {
        const portalUser = Storage.get('portalUser');
        const isAuthorized = this.props.user.authorize;

        return (
            <div className='auth-container'>
                <div className='logo'>
                    <LogoIcon/>
                </div>
                <div className='auth'>
                    <div className='auth-form'>
                        <div className='card'>
                            <div className='header'>
                                <div className='label'>Вход</div>
                            </div>
                            <div className='radio-container'>
                                <div className={`radio-button ${this.state.activeTab === 'portal' ? 'selected' : ''}`}
                                     onClick={() => this.setState({activeTab: 'portal'})}>
                                    <div className='image'>
                                        <img src={LoginPortalIcon} alt='img'/>
                                    </div>
                                    <div className='content'>
                                        <div className='title'>Профиль для пользователя</div>
                                        <div className='description'>Поиск пива, отзывы и портал</div>
                                    </div>
                                </div>
                                <div className={`radio-button ${this.state.activeTab === 'partners' ? 'selected' : ''}`}
                                     onClick={() => this.setState({activeTab: 'partners'})}>
                                    <div className='image'>
                                        <img src={LoginBusinessIcon} alt='img'/>
                                    </div>
                                    <div className='content'>
                                        <div className='title'>Профиль для бизнеса</div>
                                        <div className='description'>Система управления контентом</div>
                                    </div>
                                </div>
                            </div>
                            <div className='buttons'>
                                <Link className='button' to={`/login/${this.state.activeTab}/`}>
                                    Войти
                                </Link>
                                <Link className='button secondary' to={`/register/${this.state.activeTab}/`}>
                                    Зарегистрироваться
                                </Link>
                            </div>
                        </div>
                        <div className='extra'>
                            <Link className='forgot link' to='/forgot'>Забыли пароль?</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToPropsPortal = (state) => ({
    user: state.system.user
});

const mapDispatchToPropsPortal = (dispatch) => bindActionCreators({
    updateUser,
    updateNavigationParam
}, dispatch);

export default connect(mapStateToPropsPortal, mapDispatchToPropsPortal)(withRouterHOC(withCookies(LoginBreeding)));

